import { render } from "./IconInfo.vue?vue&type=template&id=01a77868"
import script from "./IconInfo.vue?vue&type=script&lang=ts"
export * from "./IconInfo.vue?vue&type=script&lang=ts"
script.render = render

export default script